import { CreateTagRequestBody } from "@seneca/tags-service-types";

import { getClient } from "services";

import { createTag as createTagAction } from "../state/admin";

const getTagServiceClient = () => getClient("tagService");

export function makeCreateTag(createActionFactory: any) {
  const createTag = createActionFactory({
    requestFunction: (tag: Omit<CreateTagRequestBody, "type">) =>
      getTagServiceClient().createTag(tag),
    storeAction: createTagAction
  });

  const createCategory = createActionFactory({
    requestFunction: (category: Omit<CreateTagRequestBody, "type">) =>
      getTagServiceClient().createCategory(category),
    storeAction: createTagAction
  });

  return {
    createTag,
    createCategory
  };
}
